import React from 'react';
import PropTypes from 'prop-types';
import { View } from 'react-native';
import { pure } from '@dbk-legacy/ui-react-utils';

import { ChangeIndicatedCurrency } from '../../../../../../src/components/common/number';
import ListView from '../../../../../../src/components/common/list-view';
import TouchableListItem from '../../../../../../src/components/common/touchable-list-item';
import TableRow from '../../../../../../src/components/common/table-row';
import { Large } from '../../../../../../src/components/common/text';

import { MARKER_COLOURS, NO_DATA, KEY_CODE } from '../../../constants';
import styles from './row-asset-item.styles';

function renderAssetItem(asset, columns,messages) {
  return (
    <View testID="maturities-list" style={styles.root}>
      <TableRow style={styles.topRow}>
        <TableRow.Column testID="description" align="left">
          <Large>{asset.maturityInvCtg || NO_DATA}</Large>
        </TableRow.Column>
      </TableRow>
      <TableRow style={styles.bottomRow}>
        <TableRow.Column width={columns[0].width} align="left">
          <Large>{asset.maturityCount} {messages['app.reports.common.items']}</Large>
        </TableRow.Column>
        <TableRow.Column width={columns[1].width}>
          <ChangeIndicatedCurrency
            value={asset.maturityValue}
            renderProps={{ size: 'large' }}
            onlyNegativeStyling
            />
        </TableRow.Column>
      </TableRow>
    </View>
  );
}

function handleRowPressed(
  asset,
  setDetailTitle,
  setDetailMarketValue,
  setDetailAssets,
  changePage,
  resetDetailSort,
  e
) {
  if((e && (e.keyCode === KEY_CODE.ENTER_KEY || e.keyCode === KEY_CODE.SPACE_KEY)) || (!e)){
    setDetailTitle(asset.maturityInvCtg);
    setDetailMarketValue(asset.maturityValue);
    setDetailAssets(JSON.parse(asset.details));
    resetDetailSort();
    changePage({ pathname: `/maturities/${asset.id}` });
  }
}

function RowAssetItem({
  asset,
  columns,
  setDetailTitle,
  setDetailMarketValue,
  setDetailAssets,
  changePage,
  resetDetailSort,
  messages,
}) {
  return (
    <ListView.Row
      key={asset.id}
      markerStyle={MARKER_COLOURS[asset.id]}
      >
      <TouchableListItem onKeyDown={(e) =>
      handleRowPressed(
        asset,
        setDetailTitle,
        setDetailMarketValue,
        setDetailAssets, changePage,
        resetDetailSort,
         e
    )} onClick={() => 
        handleRowPressed(
          asset,
          setDetailTitle,
          setDetailMarketValue,
          setDetailAssets, changePage,
          resetDetailSort,
      )}>
        {renderAssetItem(asset, columns,messages)}
      </TouchableListItem>
    </ListView.Row>
  );
}

RowAssetItem.defaultProps = {
  asset: [],
  columns: [],
};

RowAssetItem.propTypes = {
  assets: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    maturityCount: PropTypes.number,
    maturityValue: PropTypes.number,
    details: PropTypes.object,
  }),
  columns: PropTypes.arrayOf(PropTypes.shape({
    width: PropTypes.number,
  })),
  setDetailTitle: PropTypes.func,
  setDetailMarketValue: PropTypes.func,
  setDetailAssets: PropTypes.func,
  changePage: PropTypes.func,
  resetDetailSort: PropTypes.func,
};

export default pure(RowAssetItem);
